import React from "react";
import YouTube from "react-youtube";

import "./VideoCard.css";

const imageCard = (props) => {
  let children = null;
  if (props.children) {
    children = <div className="videoInfo">{props.children}</div>;
  }
  let classes = "VideoCard";
  if (props.full) {
    classes += " full";
  }
  return (
    <div className={classes}>
      <YouTube videoId={props.videoId} containerClassName="youtubeContainer" />
      {children}
    </div>
  );
};

export default imageCard;
